export default window.__passdata; // get data from symfony
